import { render } from "./PianoKeyboard.vue?vue&type=template&id=3afc9ac0&scoped=true"
import script from "./PianoKeyboard.vue?vue&type=script&lang=ts"
export * from "./PianoKeyboard.vue?vue&type=script&lang=ts"

import "./PianoKeyboard.vue?vue&type=style&index=0&id=3afc9ac0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3afc9ac0"

export default script